import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ProductCard extends ThemeComponent {
    @Prop product!: Shopify.Liquid.Product;

    @Ref() quickAddTrigger!: HTMLElement;
    @Ref() quickAdd!: HTMLElement;
    @Ref() quickAddClose!: HTMLElement;

    init() {

        // Add quick add click event listeners
        this.handleQuickAddEvents();

        // Add cart item added event listener
        this.handleCartItemAddedEvent();
    }

    handleQuickAddEvents() {

        // Trigger
        this.$listen(this.quickAddTrigger, 'click', () => {
            this.quickAdd.classList.add('product-quick-add--active');
        });

        // Close
        this.$listen(this.quickAddClose, 'click', () => {
            this.quickAdd.classList.remove('product-quick-add--active');
        });

        // Close - (quick add outer)
        this.$listen(this.quickAdd, 'click', (e) => {
            if (e.target) {
                const clickedElement = e.target as HTMLElement;
                if (clickedElement === this.quickAdd) {
                    this.quickAdd.classList.remove('product-quick-add--active');
                }
            }
        });
    }

    handleCartItemAddedEvent() {
        document.addEventListener('cartItemAdded', () => {
            this.quickAdd.classList.remove('product-quick-add--active');
        });
    }
}
